import * as React from "react"
import {Box, Chip} from "@mui/material";


export default function tagColumn() {
    return {
        name: 'tags',
        label: 'Tags',
        options: {
            filter: false,
            setCellProps: () => ({ sx: { textAlign: "center" } }),
            customBodyRowRenderLite: value => <Box
                display="flex"
                justifyContent="center"
                gap={.5}
                flexWrap="wrap"
            >
                { value?.map((tagName, idx) => <Chip
                    color="success"
                    key={idx}
                    label={tagName}
                />) }
            </Box>
        }
    }
}